import { Navigate } from "react-router-dom";
import { PR_ANALYSIS_PATH } from "../ROUTES";

export default function LoggedInIndexPage(): JSX.Element {
  return <Navigate replace to={PR_ANALYSIS_PATH} />;
}
